// src/components/courses/CourseCard.jsx
import React from 'react';
import PropTypes from 'prop-types';
import FeatureList from './FeatureList';

const CourseCard = ({ course }) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="relative h-48 md:h-56">
        <img
          src={course.imagePath}
          alt={course.title}
          className="object-cover w-full h-full"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/assets/images/placeholder-course.png'; // Placeholder image
          }}
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">{course.title}</h3>
        <p className="text-gray-600 text-sm mb-3">
          Starts: {course.startDate} - Ends: {course.endDate}
        </p>
        <div className="mb-4">
          <h4 className="text-md font-semibold text-gray-700 mb-1">Key Features:</h4>
          <FeatureList features={course.features} />
        </div>
        <div className="flex items-center mb-4">
          {course.discountAvailable ? (
            <>
              <span className="text-red-500 font-semibold mr-2">₹{course.discountedPrice}</span>
              <span className="text-gray-500 line-through">₹{course.originalPrice}</span>
            </>
          ) : (
            <span className="text-gray-800 font-semibold">₹{course.originalPrice}</span>
          )}
        </div>
        <p className="text-gray-500 text-xs mb-2">Valid Until: {course.validUntil}</p>
        <button className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline transition duration-300">
          Enroll Now
        </button>
      </div>
    </div>
  );
};

CourseCard.propTypes = {
  course: PropTypes.shape({
    title: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    features: PropTypes.arrayOf(PropTypes.string).isRequired,
    originalPrice: PropTypes.number.isRequired,
    discountedPrice: PropTypes.number,
    validUntil: PropTypes.string.isRequired,
    discountAvailable: PropTypes.bool,
    imagePath: PropTypes.string.isRequired,
  }).isRequired,
};

export default CourseCard;